import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from '../../style'

import Container from '../../partials/Container'
import GroupForm from '../../partials/GroupForm'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('User', 'Auth', 'Config')
@observer
export class CommunityGroup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        name: ''
      }
    }
  }

  componentWillMount () {
    const _findGroupsLoop = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending) {
          return _findGroupsLoop()
        }

        this.props.User.getAllGroups().then(() => {
          const group = this.props.User.groups
            .slice()
            .find(g => g.id === this.props.match.params.groupId)

          if (!group) {
            return
          }

          this.setState({
            ...this.state,
            editor: {
              ...this.state.editor,
              name: group.name
            }
          })
        })
      }, 500)
    }

    const group = this.props.User.groups
      .slice()
      .find(g => g.id === this.props.match.params.groupId)

    if (!group) {
      return _findGroupsLoop()
    }

    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        name: group.name
      }
    })
  }

  onPermClick (e) {
    const name = e.currentTarget.dataset.name
    const group = this.props.User.groups
      .slice()
      .find(g => g.id === this.props.match.params.groupId)

    return this.props.User.patchGroup(group.id, 'permissions', {
      ...(group.permissions[name]
        ? Object.keys(group.permissions).reduce(
            (obj, p) => ({
              ...obj,
              ...(p !== name ? { [name]: true } : {})
            }),
            {}
          )
        : {
          ...group.permissions,
          [name]: true
        })
    })
  }

  onNameInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        name: e.target.value
      }
    })
  }

  onNameInputBlur (e) {
    if (this.state.editor.name.length > 0) {
      this.props.User.patchGroup(
        this.props.match.params.groupId,
        'name',
        this.state.editor.name
      )
    }
  }

  goBack (e) {
    e.preventDefault()
    return this.props.history.push(
      this.props.match.url.replace(`/${this.props.match.params.groupId}`, '')
    )
  }

  render () {
    const group = this.props.User.groups.find(
      g => g.id === this.props.match.params.groupId
    )

    if (!group) {
      return null
    }

    return (
      <Container {...this.props}>
        <Row>
          <Col>
            <Row>
              <Col xs='12' lg='6'>
                <h2 className={css(style.headers.h2)}>Edit Group</h2>
              </Col>
              <Col>
                <Row>
                  <Col />
                  <Col>
                    <span
                      onClick={this.goBack.bind(this)}
                      className={css(style.buttons.button, style.buttons.red)}
                    >
                      Go Back
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <GroupForm
              theme={THEME_LIST[this.props.Config.theme]}
              group={group}
              editor={this.state.editor}
              onPermClick={this.onPermClick.bind(this)}
              onNameInputBlur={this.onNameInputBlur.bind(this)}
              onNameInputChange={this.onNameInputChange.bind(this)}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default CommunityGroup



// WEBPACK FOOTER //
// ./src/components/User/Group/Edit/index.js